@if (IsLoading) {
  <div class="spinnerPlacement">
    <app-spinner></app-spinner>
  </div>
}
<!-- Titlebar
================================================== -->
<div id="titlebar" class="property-titlebar margin-bottom-0" [hidden]="!IsDiv">
<div class="container">
  <div class="row">
    <div class="col-md-12 pl-0">

      <a [routerLink]="'/properties'" class="back-to-listings" aria-label="Back to home page"></a>
      <div class="property-title">
        <h1>{{propertyModel?.Title}} <span class="property-badge">{{propertyModel?.Type}} For
        {{propertyModel?.Purpose}}</span></h1>
        <span>
          <div class="listing-address">
            <h5>
              <i class="fa fa-map-marker"></i>
              {{propertyModel?.Location}}, {{propertyModel?.City}}
            </h5>
          </div>
        </span>
      </div>
    </div>
  </div>
</div>
</div>

<!-- Content
================================================== -->

<div class="container"  [hidden]="!IsDiv">
  <div class="row">
    <div class="col-lg-8 col-md-7">
      <div class="row">
        <div class="col-md-12 padding-none">
          <div class="item">
            <div class="clearfix">
              <ul id="image-gallery" class="gallery light-gallery list-unstyled  lightSlider lSSlide img-content text-center img-valign">
                <li  *ngFor="let image of propertyModel?.Images;" [attr.data-thumb]="image" (click)="showSlider(propertyModel)" >
                  <img [src]="image" height="520px" width="100%" />
                </li>
              </ul>
              <span class="open-light-gallery"><i class="fa fa-search-plus"></i> Click Photo to Enlarge</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row margin-top-5 margin-bottom-40">
        <div class="col-md-12 padding-none">
          <div class="property-description">
            <ul class="property-main-features">
              <li>PKR<span>{{propertyModel?.PriceInWords}}</span></li>
              <li>Area <span>{{propertyModel?.Area}} - {{propertyModel?.AreaUnit}} </span></li>
              <li *ngIf="propertyModel?.BedRooms != ''">Bedrooms <span>{{propertyModel?.BedRooms}}</span></li>
              <li *ngIf="propertyModel?.BathRooms != ''">Bathrooms <span>{{propertyModel?.BathRooms}}</span></li>
            </ul>

            <h3 class="desc-headline">Description</h3>
            <div class="show-more visible">
              <div [innerHTML]="propertyModel?.Description" class="pro-desc-background"></div>
            </div>
            <h3 *ngIf="propertyModel?.OtherFeatures != undefined && propertyModel?.OtherFeatures.length != 0"
            class="desc-headline">Features</h3>
            <ul class="property-features checkboxes margin-top-0">
              <li *ngFor="let feature of propertyModel?.OtherFeatures">{{feature}}</li>
            </ul>

            <h3 class="desc-headline no-border" id="location">Location</h3>
            <div id="propertyMap-container">
              <div id="propertyMap"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-5 padding-none">
      <div class="sidebar sticky right">
        <div class="widget">
          <div class="agent-widget">
            <div class="agent-title">
              <div class="agent-photo"><img [src]="propertyModel?.ImageUrl" width="70" height="70" alt="" /></div>
              <div class="agent-details">
                <h4>{{propertyModel?.ContactFullName}}</h4>
                <span><i class="sl sl-icon-call-in"></i>{{propertyModel?.ContactPhoneNumber}}</span>
              </div>
              <div class="clearfix"></div>
            </div>
            <form (ngSubmit)="ContactPropertyOwner(contactForm)" class="submit-section" #contactForm="ngForm">
              <input type="hidden" name="subject" [(ngModel)]="Subject" #subjectControl="ngModel" />
              <input type="hidden" name="ownerEmail" [(ngModel)]="OwnerEmail" #ownerEmailControl="ngModel" />
              <input type="text" name="fullName" class="form-control input-text margin-top-5" [(ngModel)]="FullName"
                required #fullNameControl="ngModel" placeholder="Your Full Name" />
                <div class="notification error" *ngIf="fullNameControl.invalid && fullNameControl.touched">
                  <p>Full Name is required.</p>
                </div>
                <input type="email" name="emailAddress" class="form-control input-text margin-top-5"
                  [(ngModel)]="EmailAddress" required #emailControl="ngModel" placeholder="Your Email" />
                  <div class="notification error" *ngIf="emailControl.invalid && emailControl.touched">
                    <p>Email is required.</p>
                  </div>

                  <input type="phone" maxlength="16" (keypress)="numberOnly($event)" onpaste="return false;"
                    ondrag="return false;" ondrop="return false;" name="phoneNumber"
                    class="form-control input-text margin-top-5" [(ngModel)]="PhoneNumber" required #phoneControl="ngModel"
                    placeholder="Your Phone" />
                    <div class="notification error" *ngIf="phoneControl.invalid && phoneControl.touched">
                      <p>Phone number is required.</p>
                    </div>

                    <textarea name="message" [(ngModel)]="Message" required #messageControl="ngModel"
                    class="input-text margin-top-5"></textarea>
                    <div class="notification error" *ngIf="messageControl.invalid && messageControl.touched">
                      <p>Message is required.</p>
                    </div>
                    <button class="button fullwidth margin-top-15">Send Email</button>
                    <br/>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="dynamicLightGallery"></div>
      </div>
